import * as index from './number/component-lib.esm.js';
import { truncate } from '../utils/component-lib.esm7.js';
import { capitalize } from '../utils/component-lib.esm10.js';
const installFilters = {
  install: Vue => {
    for (let key in index) {
      Vue.filter(key, index[key]);
    }
    Vue.filter('truncate', truncate);
    Vue.filter('capitalize', capitalize);
  }
};
export { installFilters };